import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../lib/loopback'

const analistaMercadoriaRepository = createRepository({
  path: 'analista-mercadorias',
  parentPath: 'mercadorias',
  relationType: 'path',
  restApi,
  queryTransform: {
    ...paginate
  }
})

analistaMercadoriaRepository.remove = async ({ id }) => {
  if (!id) throw new Error('ID é obrigatório para delete')
  const uri = `analista-mercadorias/${id}`
  const response = await restApi.delete(uri)
  return {
    ok: response.ok,
    data: response.data
  }
}

analistaMercadoriaRepository.getOne = ({ id }) => {
  return restApi.get(`analista-mercadorias/${id}`)
}

export default analistaMercadoriaRepository
